import { computed, type Ref } from 'vue'
import { gql } from '@apollo/client/core'
import { useQuery } from '/@/core/graphql'
import {
  type DesignerMembershipPlan,
  type PricingExperiment,
} from '/@/common/plans/types'
import { designerSignupMembershipPlanFragment } from './fragments'

export function useMembershipPlansData(
  experiment: Ref<PricingExperiment | undefined | null>,
) {
  const { result, loading } = useQuery<{
    membershipPlan: { membershipPlans: { plans: DesignerMembershipPlan[] } }
  }>(
    gql`
      ${designerSignupMembershipPlanFragment}
      query getMembershipPlans($experiment: PricingExperiment) {
        membershipPlan {
          membershipPlans(experiment: $experiment) {
            plans {
              ...DesignerMembershipPlanProps
            }
          }
        }
      }
    `,
    { experiment },
  )

  const membershipPlans = computed(() => {
    return result.value?.membershipPlan?.membershipPlans?.plans ?? []
  })

  return { membershipPlans, loading }
}
